
import fetch from '@/common/js/http';

const mindInfo = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {

    // 工时审批查询当日
    getuserWxMainInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: 'performance/userWxMainInfo',
          method: 'get',
          params: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },
  }
}
export default mindInfo



// WEBPACK FOOTER //
// ./src/vuex/modules/mind.js